export default "__VITE_ASSET__df922732__"